export enum ResourceApi {
  // Still used by the shared compose-drawer favorites picker.
  GetFavorite = '/api/v1.0/resource/favorite',
  // v2 (ADMIN_API_BASE_URL) — used by the webapp favorites lists (home tab +
  // /resources/favorites page).
  GetFavoriteV2 = '/api/v2/Resource/favorite',
  // v2 (ADMIN_API_BASE_URL) — replaces /api/v1.0/resource/featured.
  GetFeatured = '/api/v2/Resource/featured',
  GetPopular = '/WebApi/GetPopularResources',
  // v2 (ADMIN_API_BASE_URL) — replaces /api/v1.0/resource/whatsnew/paged.
  GetRecentlyUploaded = '/api/v2/Resource/recentlyuploaded',
  AddToFavorites = '/WebAPI/AddToFavorites',
  RemoveFromFavorites = '/WebAPI/DeleteFavorite',
  GetShareableLink = '/WebAPI/GetLink',
  GetCategoriesAndResources = '/WebAPI/GetCategoriesAndResources',
  GetUserResources = '/api/v1.0/resource/user/:categoryId',
  // v2.0 (ADMIN_API_BASE_URL) — returns HasQRCode / HasCoverPage per resource.
  GetCompanyResources = '/api/v2.0/resource/company/:categoryId',
  CreateResource = '/WebAPI/UploadUserResource',
  CreateWebLinkResource = '/api/v1.0/resource/createweblink',
  GetResource = '/api/v1.0/resource/:resourceId',
  // v2 (ADMIN_API_BASE_URL) — the same resource plus the print-order fields
  // (EnableAddToCart, HasQRCode, HasCoverPage, HasLocation).
  GetResourceV2 = '/api/v2/Resource/:id',
  GetChildResources = 'webapi/GetChildResources',
  GetResourceBookmarks = 'webapi/GetResourceBookmarks',
  SaveResourceBookmarks = 'webApi/SaveResourceBookmarks',
  DeleteUserResource = '/WebAPI/deleteuserresource',
  ProductAssociatedResources = '/api/v1.0/resource/akeneoProduct'
}

export enum AdminResourceApi {
  GetResources = '/api/v2/admin/ResourceCategory/:id/resources',
  GetResource = '/api/v2/admin/Resources/:id',
  GetCategoryResources = '/api/v2/admin/Resources/:id/getCompanyResources',
  GetCategoryGroups = '/api/v2/admin/groups/getGroupsFromResourceCategories',
  ChangeResourcesCategory = 'api/v2/admin/Resources/:sourceCategoryID/changeCategory',
  ChangeResourceStatus = '/api/v2/admin/Resources/:resourceId/changeStatus/:statusId',
  BatchChangeResourceStatus = '/api/v2/admin/Resources/batchChangeStatus/:statusId',
  DeleteResource = '/api/v2/admin/Resources/:id',
  BatchDeleteResources = '/api/v2/admin/Resources/batchDelete',
  ResourceTags = '/api/v2/admin/tags',
  UpdateResource = '/api/v2/admin/Resources/update',
  CreateResource = '/api/v2/admin/Resources/create',
  GetResourceProcessStatus = '/api/v2/admin/Resources/resourceProcessingStatus',
  ResourceUploadFinished = '/api/v2/admin/Resources/uploadFinish',
  ChangeResourceThumbnail = '/api/v2/admin/Resources/:id/changeThumbnail',
  UpdateResourceCategories = '/api/v2/admin/Resources/updateCategoryMembership',
  UpdateResourcesIsShareable = '/api/v2/admin/Resources/batchIsShareable',
  GetCategoryAdminResources = '/api/v2/admin/ResourceCategory/:id/categoryResources',
  GetFeaturedResources = '/api/v2/admin/Resources/getFeaturedResources',
  RemoveFeaturedResource = '/api/v2/admin/Resources/:id/featured',
  AddFeaturedResources = '/api/v2/admin/Resources/featured',
  GetFeaturedResourcesGroups = '/api/v2/admin/groups/getGroupsFromFeaturedResources',
  GetFeaturedResource = '/api/v2/admin/Resources/:id/featured',
  EditFeaturedResource = '/api/v2/admin/Resources/featured',
  ChangeFeaturedResourcesOrder = 'api/v2/admin/Resources/featuredChangeOrder'
}
